// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5873":"fd0ff8c8","7736":"9adb6eba"}[chunkId] || chunkId) + "." + {"1310":"0d99dcf86d8b142a","5302":"985497e28e4df2b2","5873":"fffda3aa659c1859","5992":"c074d3e154302e11","7736":"4d7667fa126565bb"}[chunkId] + ".js";
};